import { render, staticRenderFns } from "./CustomerVitalCreateOrEdit.vue?vue&type=template&id=2374917d&"
import script from "./CustomerVitalCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./CustomerVitalCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports